<!--
  - Copyright (c) 2023-2024. Haodong JU
  -->

<template>
  <div>
    <template v-if="!QRReady">
      <no-product-page />
    </template>
    <div
      v-else
      class="mt-4"
    >
      <v-tabs
        v-model="tab"
        background-color="transparent"
        color="black"
        style="background: transparent"
      >
        <v-tab>{{ $t('TakeawayAnnouncement') }}</v-tab>
      </v-tabs>
      <v-divider />
      <v-tabs-items
        v-model="tab"
        class="mt-4"
        style="background: transparent"
      >
        <v-tab-item>
          <q-r-announcement />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import { getActiveProductCode } from '@/model/dataLayer/api/SaaS/user'
import { ProductCodes } from '@/model/dataLayer/api/SaaS/product'
import NoProductPage from '@/views/widget/commonLogic/NoProductPage'
import QRAnnouncement from '@/views/AadenPages/extraModules/qrScan/QRAnnouncement'

export default {
  name: 'QRIndex',
  components: {
    QRAnnouncement,
    NoProductPage
  },
  data () {
    return {
      tab: null,
      QRReady: false
    }
  },
  async mounted () {
    try {
      const res = await getActiveProductCode()
      this.QRReady = res.includes(ProductCodes.scanToOrder)
    } catch (e) {
      console.log(e)
    }
  }
}
</script>

<style scoped>
.text-slate-500 {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity));
}

.text-slate-600 {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity));
}
</style>
